import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Table } from '@cureskin/api-client';
import { ConnectionService } from '../connection-service';

@Injectable()
export class RegimenService {
  private readonly regimensSource: BehaviorSubject<Array<Table.Regimen>> = new BehaviorSubject<Array<Table.Regimen>>([]);
  regimens$: Observable<Array<Table.Regimen>> = this.regimensSource.asObservable();

  constructor(private readonly conn: ConnectionService) {}

  async fetchRegimensForUser(user: Table.User): Promise<Array<Table.Regimen>> {
    this.regimensSource.next([]);
    if (!user?.id) {
      return [];
    }
    const regimens: Array<Table.Regimen> = await this.conn.findRegimens({
      where: { forUser: user },
      include: ['concernsLanguageString', 'night.product' as 'night', 'morning.product' as 'morning'],
      project: [
        'regimenId',
        'updateVersion',
        'concernsLanguageString.en' as 'concernsLanguageString',
        'title',
        'night',
        'morning',
        'active',
        'products',
        'class',
      ],
    });
    this.regimensSource.next(regimens);
    return regimens;
  }
}
